import { Box } from "@chakra-ui/react";
import * as React from "react";

export interface IconProps {
  color?: string;
  size?: string;
}

export interface IconCircleProps {
  Icon: React.ComponentType<IconProps>;
  size?: "xs" | "sm" | "md" | "lg";
  variant?: "flat"; // FIXME
}

export default function IconCircle({ Icon, size }: IconCircleProps) {
  return (
    <Box
      bg={"{gradients.icon.circle}" as any}
      borderColor="white"
      borderRadius="full"
      borderWidth="2"
      boxShadow="icon.circle"
      fontSize={size || "md"}
      p="3"
    >
      <Icon color="#FFFFFF" />
    </Box>
  );
}
